import { useOktaAuth } from '@okta/okta-react';
import { useContext, useState, useEffect } from 'react';
import { useQuery, useQueryClient } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { getMyRole } from '../api/Network';
import { NavItem, navigationItems } from '../App';
import { ConfirmationModalContext } from '../contexts/ConfirmationProvider';
import { MyRoleContext } from '../contexts/AdminContext';
import LoadingPage from '../components/LoadingPage';

const Home = () => {
  const { showModal } = useContext(ConfirmationModalContext);
  const { setRole, role } = useContext(MyRoleContext);
  const queryClient = useQueryClient();
  const [env, setEnv] = useState<string>();
  const { authState } = useOktaAuth();
  const navigate = useNavigate();

  const { data: myRoleData, isLoading } = useQuery(['getMyRole'], () => getMyRole(), {
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (myRoleData?.data !== undefined) {
      setRole(myRoleData.data);
    }
  }, [myRoleData?.data, setRole]);

  if (isLoading || !authState?.idToken) {
    return (
      <div className="flex items-center justify-center h-screen">
        <LoadingPage />
      </div>
    );
  }

  const userIsAdmin = role?.isAdmin === true;
  // Getting user name
  const claims = authState.idToken.claims;
  const user = claims?.name || 'User';
  const navItems = navigationItems
    .slice(1)
    .filter((i) => (!i.hideInProd || env !== 'prod') && (i.title !== 'Admin' || userIsAdmin));

  const navigateToPage = (navItem: NavItem) => {
    navigate(navItem.route);
  };

  const navigationElements = navItems.map((n) => {
    return (
      <div key={n.title} className="flex border-solid border-primary border-2 rounded-box ">
        {n.children ? (
          <div key={n.title} className="  my-1 w-96">
            <div className="p-4 text-primary text-xl flex flex-row justify-center">
              <div>{n.title}</div>
            </div>
            <div className="h-96 overflow-auto flex flex-col">
              {n.children
                ?.filter((i) => (!i.hideInProd || env !== 'prod') && (i.title !== 'Admin' || userIsAdmin))
                .map((c) => {
                  return (
                    <button key={c.route} className="btn btn-sm btn-ghost" onClick={() => navigateToPage(c)}>
                      <div className="font-normal text-lg text-base-content">{c.title}</div>
                      <div>{c.icon}</div>
                    </button>
                  );
                })}
            </div>
          </div>
        ) : (
          <div key={n.route} className="py-2">
            <li>
              <div className="flex flex-row align-center justify-between" onClick={() => navigateToPage(n)}>
                <div className="text-lg">{n.title}</div>
                <div>{n.icon}</div>
              </div>
            </li>
          </div>
        )}
      </div>
    );
  });
  return (
    <div className="card bg-base-100 shadow-xl overflow-auto w-full ">
      <div className="card-body p-2 sm:p-8">
        <div className="flex flex-col justify-center gap-4">
          <h2 className="card-title text-primary m-4 justify-center">Welcome, {user}</h2>

          <div className="flex flex-row flex-wrap gap-6 justify-center">{navigationElements}</div>
        </div>
      </div>
    </div>
  );
};

export default Home;
